import { render, staticRenderFns } from "./ScansTab.vue?vue&type=template&id=1dce8af2&"
import script from "./ScansTab.vue?vue&type=script&lang=js&"
export * from "./ScansTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ScansTab.vue"
export default component.exports